module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/icon_title_resort-0e759168b2ddd95166aacd002579622b.svg";